(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;
  const FX = window.RB.FX;

  Object.assign(FX.OPS, {
    revealHand(state, item, op, p, opp) {
      const who = op.who === "each" ? [p, opp] : [op.who === "opponent" ? opp : p];
      if (op.lookFacedown) {
        state.fx.push({ id: state.nextFxId++, k: "seeFacedown", player: p, dur: "turn" });
        FX.opLog(state, item, "reveal", state.players[p].name + " can look at facedown cards this turn.");
        const peek = [];
        for (const bf of state.battlefields) {
          for (const fdIid of Flow.hiddenAt(state, bf)) if (state.objs[fdIid].owner !== p) peek.push(fdIid);
        }
        FX.emit(state, { type: "peekFacedown", player: p, iids: peek, cardIds: FX.cardIdsOf(state, peek) });
      }
      for (const w of who) {
        const hand = state.players[w].hand.slice();
        FX.emit(state, {
          type: "revealCards", player: w, iids: hand, source: "hand", label: item.label,
          cardIds: FX.cardIdsOf(state, hand),
        });
        FX.opLog(state, item, "reveal", state.players[w].name + " reveals their hand (" +
          hand.map(function (i) { return Core.name(state, i); }).join(", ") + ").", hand);
      }
      return;
    },

    revealHandPick(state, item, op, p, opp) {
      const who = op.who === "opponent" ? opp : p;
      const key = op.bind || "_rh";
      if (item.targets[key] !== undefined) return;
      let hand = state.players[who].hand.slice();
      if (op.notType) hand = hand.filter(function (i2) { return !Core.isType(state, i2, op.notType); });
      if (op.type) hand = hand.filter(function (i2) { return Core.isType(state, i2, op.type); });
      if (op.domain) {
        hand = hand.filter(function (i2) {
          return ((Core.card(state, i2) || {}).domains || []).indexOf(op.domain) >= 0;
        });
      }
      if (!hand.length) { item.targets[key] = []; FX.opLog(state, item, "reveal", item.label + ": no matching card in that hand."); return; }
      RB.FX.emit(state, {
        type: "revealCards", player: who, iids: state.players[who].hand.slice(), source: "hand", label: item.label,
        cardIds: FX.cardIdsOf(state, state.players[who].hand),
      });
      state.pending = {
        kind: "choose", player: p, tag: "target",
        prompt: op.prompt || "Choose a card from that hand",
        src: item.label, srcIid: item.iid,
        cands: hand, min: op.optional ? 0 : 1, max: 1, bind: key,
      };
      return "wait";
    },

    revealTopCount(state, item, op, p, opp) {
      const peek = FX.stepDeckPeek(state, item, p, "peek" + item.pc);
      if (peek) return peek;
      const player = state.players[p];
      const n = Math.min(op.n || 1, player.mainDeck.length);
      const revealed = player.mainDeck.slice(0, n);
      let count = 0;
      const names = [];
      for (const iid2 of revealed) {
        names.push(Core.name(state, iid2));
        if (!op.matchKw || Core.hasKw(state, iid2, op.matchKw)) count++;
      }
      item.vars[op.varKey || "revealed"] = count;
      if (revealed.length) {
        RB.FX.emit(state, {
          type: "revealCards", player: p, iids: revealed.slice(), source: "deck", label: item.label,
          cardIds: FX.cardIdsOf(state, revealed),
        });
      }
      FX.opLog(state, item, "reveal", item.label + " reveals: " + (names.join(", ") || "nothing") +
        (op.matchKw ? " (" + count + " " + op.matchKw + ")" : "") + ".", revealed);
      player.mainDeck.splice(0, n);
      Flow.recycleCards(state, revealed);
      return;
    },

    revealTopRune(state, item, op, p, opp) {
      const player = state.players[p];
      if (!player.runeDeck.length) { item.vars[op.varKey || "rune"] = null; return; }
      const top = player.runeDeck[0];
      const c2 = Core.card(state, top);
      const dom = c2 && c2.domains && c2.domains.length ? c2.domains[0] : null;
      RB.FX.emit(state, {
        type: "revealCards", player: p, iids: [top], source: "runeDeck", label: item.label,
        cardIds: FX.cardIdsOf(state, [top]),
      });
      FX.opLog(state, item, "reveal", item.label + " reveals " + Core.name(state, top) + " from the rune deck.", [top]);
      player.runeDeck.shift();
      Flow.recycleCards(state, [top]);
      item.vars[op.varKey || "rune"] = dom;
      return;
    },

    lookTopTake(state, item, op, p, opp) {
      const player = state.players[op.who === "opponent" ? opp : p];
      if (op.public) {
        const peek = FX.stepDeckPeek(state, item, op.who === "opponent" ? opp : p, "peek" + item.pc);
        if (peek) return peek;
      }
      const key = "look" + item.pc;
      if (item.vars[key + "Done"]) return;
      if (!item.vars[key + "Set"]) {
        const n = op.n === "untilMatch" ? player.mainDeck.length : Math.min(FX.amount(state, item, op.n), player.mainDeck.length);
        let taken = [];
        if (op.n === "untilMatch") {
          for (const iid2 of player.mainDeck) {
            taken.push(iid2);
            if (FX.lookMatches(state, item, iid2, op)) break;
          }
        } else {
          taken = player.mainDeck.slice(0, n);
        }
        if (!taken.length) { item.vars[key + "Done"] = 1; return; }
        player.mainDeck.splice(0, taken.length);
        item.vars[key + "Set"] = taken;
        RB.FX.emit(state, {
          type: "revealCards", player: p, iids: taken.slice(), source: "deck", label: item.label, private: !op.public,
          cardIds: FX.cardIdsOf(state, taken),
        });
      }
      const set = item.vars[key + "Set"];

      const lookPlay = FX.stepLookPlay(state, item, key, set, p);
      if (lookPlay === "wait") return "wait";
      if (lookPlay === "repeat") return "repeat";
      const eligible = set.filter(function (i2) {
        if (!FX.lookMatches(state, item, i2, op)) return false;
        return op.take === "hand" || FX.lookPlayable(state, item, i2, op, p);
      });
      if (eligible.length && FX.ask(state, item, key + "Pick", {
        player: p, tag: "target", cands: eligible, min: op.optional ? 0 : 1, max: 1,
        prompt: op.prompt || (op.optional ? "Take one (or none)" : "Take one"),
      })) return "wait";
      const picks = FX.picksOf(item.vars[key + "Pick"]);
      const rest = set.filter(function (i2) { return picks.indexOf(i2) < 0; });
      if (rest.length) {
        if (op.restTo === "trash") for (const r2 of rest) Flow.toTrash(state, r2);
        else if (op.restTo === "hand") for (const r2 of rest) Flow.toHand(state, r2);
        else if (op.restTo === "top") {
          for (let i2 = rest.length - 1; i2 >= 0; i2--) player.mainDeck.unshift(rest[i2]);
        } else Flow.recycleCards(state, rest);
      }
      item.vars[key + "Done"] = 1;
      if (op.varKey) item.vars[op.varKey] = picks.length ? 1 : 0;
      if (op.bind) item.targets[op.bind] = picks.slice();
      if (!picks.length) return;
      const pick = picks[0];
      if (op.take === "hand") {
        const inHand = Flow.toHand(state, pick);
        if (op.bind) item.targets[op.bind] = [inHand || pick];
        return;
      }
      const banished = Flow.toBanish(state, pick);
      if (op.bind) item.targets[op.bind] = [banished || pick];
      const srcIid = item.source !== undefined && item.source !== null ? item.source : item.iid;
      const srcLoc = op.playHere && srcIid !== undefined && srcIid !== null
        ? (state.objs[srcIid] || {}).loc : null;
      const playOpts = {
        fromZone: "banish", viaEffect: true,
        waive: op.waive || null, energyLess: FX.amount(state, item, op.energyLess || 0),
      };
      if (srcLoc && srcLoc.t === "bf") playOpts.hereBf = srcLoc.iid;
      RB.Play.beginPlay(state, p, banished || pick, playOpts);
      FX.opLog(state, item, "play", state.players[p].name + " plays " + Core.name(state, banished || pick) + " (" + item.label + ").", [banished || pick]);
      return;
    },

    lookRecycleOrder(state, item, op, p, opp) {
      const lroPlayer = state.players[op.who === "opponent" ? opp : p];
      const lroKey = "lro" + item.pc;
      if (item.vars[lroKey + "Done"]) return;
      if (!item.vars[lroKey + "Set"]) {
        const lroN = Math.min(FX.amount(state, item, op.n === undefined ? 2 : op.n), lroPlayer.mainDeck.length);
        if (!lroN) { item.vars[lroKey + "Done"] = 1; return; }
        const lroTaken = lroPlayer.mainDeck.slice(0, lroN);
        lroPlayer.mainDeck.splice(0, lroN);
        item.vars[lroKey + "Set"] = lroTaken;
        RB.FX.emit(state, {
          type: "revealCards", player: p, iids: lroTaken.slice(), source: "deck", label: item.label,
          private: !op.public,
          cardIds: FX.cardIdsOf(state, lroTaken),
        });
      }
      const lroSet = item.vars[lroKey + "Set"];
      const lroLookPlay = FX.stepLookPlay(state, item, lroKey, lroSet, p);
      if (lroLookPlay === "wait") return "wait";
      if (lroLookPlay === "repeat") return "repeat";
      if (!lroSet.length) { item.vars[lroKey + "Done"] = 1; return; }
      if (FX.ask(state, item, lroKey + "Rec", {
        player: p, tag: "target", cands: lroSet.slice(), min: 0, max: lroSet.length,
        prompt: op.prompt || "Recycle any of them (choose none to keep them all)",
      })) return "wait";
      if (!item.vars[lroKey + "Recycled"]) {
        const lroRec = FX.picksOf(item.vars[lroKey + "Rec"]);
        item.vars[lroKey + "Keep"] = lroSet.filter(function (i2) { return lroRec.indexOf(i2) < 0; });
        if (lroRec.length) Flow.recycleCards(state, lroRec);
        item.vars[lroKey + "Recycled"] = 1;
        return "repeat";
      }
      const lroKeep = item.vars[lroKey + "Keep"] || [];
      const lroOrder = item.vars[lroKey + "Order"] || [];
      const lroLeft = lroKeep.filter(function (i2) { return lroOrder.indexOf(i2) < 0; });
      if (lroLeft.length > 1) {
        const lroTopKey = lroKey + "top" + lroOrder.length;
        if (FX.ask(state, item, lroTopKey, {
          player: p, tag: "target", cands: lroLeft.slice(), min: 1, max: 1,
          prompt: op.orderPrompt || "Which one goes back on top?",
        })) return "wait";
        item.vars[lroKey + "Order"] = lroOrder.concat(FX.picksOf(item.vars[lroTopKey]));
        return "repeat";
      }
      const lroFinal = lroOrder.concat(lroLeft);
      for (let i2 = lroFinal.length - 1; i2 >= 0; i2--) lroPlayer.mainDeck.unshift(lroFinal[i2]);
      item.vars[lroKey + "Done"] = 1;
      return;
    },

    keepAndRecycle(state, item, op, p, opp) {
      const key = "kr" + item.pc;
      const groups = op.groups || [];
      const order = [];
      for (const who of [p, opp]) for (let gi = 0; gi < groups.length; gi++) order.push({ who: who, gi: gi });
      const idx = item.vars[key + "i"] || 0;
      if (idx >= order.length) {
        const doomed = item.vars[key + "doomed"] || [];
        if (doomed.length) Flow.recycleCards(state, doomed);
        return;
      }
      const step = order[idx];
      const g = groups[step.gi];
      const pool = g.zone === "hand"
        ? state.players[step.who].hand.slice()
        : Core.boardObjs(state, function (o, i2) {
          return o.controller === step.who && !o.attachedTo && Core.isType(state, i2, g.type);
        });
      if (pool.length <= g.keep) {
        item.vars[key + "i"] = idx + 1;
        return "repeat";
      }
      if (FX.ask(state, item, key + "pick", {
        player: step.who, tag: "target", cands: pool, min: g.keep, max: g.keep,
        prompt: (op.prompt || "Keep") + " " + g.keep + " " + (g.label || g.type) + " - the rest are recycled",
      })) return "wait";
      const kept = FX.picksOf(item.vars[key + "pick"]);
      delete item.vars[key + "pick"];
      const doomed = (item.vars[key + "doomed"] || []).concat(pool.filter(function (t) { return kept.indexOf(t) < 0; }));
      item.vars[key + "doomed"] = doomed;
      item.vars[key + "i"] = idx + 1;
      return "repeat";
    },

    eachLookAndPlay(state, item, op, p, opp) {
      const key = "elp" + item.pc;
      const order = [opp, p];
      const picked = item.vars[key + "picked"] || {};
      const i = item.vars[key + "i"] || 0;
      if (i < order.length) {
        const who = order[i];
        const deck = state.players[who].mainDeck;
        const n = Math.min(FX.amount(state, item, op.n), deck.length);
        if (!n) { item.vars[key + "i"] = i + 1; return "repeat"; }
        const set = item.vars[key + "set" + who] || deck.slice(0, n);
        if (!item.vars[key + "set" + who]) {
          item.vars[key + "set" + who] = set;
          deck.splice(0, n);
          RB.FX.emit(state, {
            type: "revealCards", player: who, iids: set.slice(), source: "deck", label: item.label, private: true,
            cardIds: FX.cardIdsOf(state, set),
          });
        }
        if (FX.ask(state, item, key + "pick", {
          player: who, tag: "target", cands: set.slice(), min: 1, max: 1,
          prompt: op.prompt || "Choose one to play - the rest are recycled",
        })) return "wait";
        const pick = FX.picksOf(item.vars[key + "pick"])[0];
        delete item.vars[key + "pick"];
        picked[who] = pick;
        item.vars[key + "picked"] = picked;
        const rest = set.filter(function (t) { return t !== pick; });
        if (rest.length) Flow.recycleCards(state, rest);
        item.vars[key + "i"] = i + 1;
        return "repeat";
      }
      const j = item.vars[key + "j"] || 0;
      if (j < order.length) {
        item.vars[key + "j"] = j + 1;
        const who = order[j];
        const cIid = picked[who];
        if (cIid && state.objs[cIid]) {
          RB.Play.beginPlay(state, who, cIid, { fromZone: "deck", viaEffect: true, waive: op.waive || "energy" });
          FX.opLog(state, item, "play", state.players[who].name + " plays " + Core.name(state, cIid) + " (" + item.label + ").", [cIid]);
        }
        return "repeat";
      }
      return;
    },

    chooseBudget(state, item, op, p, opp) {
      const st = FX.budgetPick(state, item, op, p, "cb" + item.pc, "Choose units");
      if (typeof st === "string") return st;
      item.targets[op.bind] = st.picked.slice();
      return;
    },

    modalOnce(state, item, op, p, opp) {
      const key = "modal" + item.pc;
      const src = item.source && state.objs[item.source];
      const usedKey = "modes" + item.pc + "t" + state.turn.num;
      const castKey = "modesUsed";
      const used = src ? (src.flags[usedKey] || []) : (item.vars[castKey] || []);
      const avail = op.modes.map(function (m, i) { return i; }).filter(function (i) { return used.indexOf(i) < 0; });
      if (!avail.length) { FX.opLog(state, item, "info", item.label + ": every mode was already chosen this turn."); return; }
      if (item.vars[key] === undefined) {
        if (avail.length === 1) {
          item.vars[key] = 0;
        } else {
          FX.ask(state, item, key, {
            player: p, tag: "may", prompt: op.prompt || "Choose one",
            options: avail.map(function (i) { return op.modes[i].label; }),
          });
          return "wait";
        }
      }
      const chosen = avail[item.vars[key]];
      if (src) src.flags[usedKey] = used.concat([chosen]);
      else item.vars[castKey] = used.concat([chosen]);
      item.program = (item.program || []).slice();
      item.program.splice.apply(item.program, [item.pc + 1, 0].concat(op.modes[chosen].then));
      return;
    },

    predict(state, item, op, p, opp) {
      const player = state.players[p];
      const want = FX.amount(state, item, op.n || 1) || 1;

      const n = Math.min(want, player.mainDeck.length);
      if (!n) return;
      if (n === 1) {
        const top = player.mainDeck[0];
        if (item.vars.predictChoice === undefined) {
          state.pending = {
            kind: "choose", player: p, tag: "predict",
            prompt: "Predict: top card is " + Core.name(state, top) + ". Recycle it?",
            options: ["Recycle", "Keep on top"], varKey: "predictChoice",
          };
          return "wait";
        }
        if (item.vars.predictChoice === 0) {
          player.mainDeck.shift();
          Flow.recycleCards(state, [top]);
          FX.opLog(state, item, "zone", state.players[p].name + " recycles the top card.");
        }
        delete item.vars.predictChoice;
        return;
      }

      if (!item.vars.predictSet) item.vars.predictSet = player.mainDeck.slice(0, n);
      const set = item.vars.predictSet;
      if (item.targets._predict === undefined) {
        state.pending = {
          kind: "choose", player: p, tag: "target",
          prompt: "Predict " + n + ": choose cards to RECYCLE (the rest go back on top)",
          src: item.label, cands: set.slice(), min: 0, max: n, bind: "_predict",
        };
        return "wait";
      }
      if (!item.vars.predictRecycled) {
        const rec = item.targets._predict || [];
        for (const rIid of rec) {
          const di = player.mainDeck.indexOf(rIid);
          if (di >= 0) player.mainDeck.splice(di, 1);
        }
        if (rec.length) Flow.recycleCards(state, rec);
        item.vars.predictRecycled = 1;
        item.vars.predictRemaining = set.filter(function (x) { return rec.indexOf(x) < 0; });
        item.vars.predictOrder = [];
        FX.opLog(state, item, "reveal", player.name + " predicts " + n + " and recycles " + rec.length + ".");
      }
      const remaining = item.vars.predictRemaining;
      const order = item.vars.predictOrder;
      while (remaining.length - order.length > 1) {
        if (item.vars.predictPick === undefined) {
          const left = remaining.filter(function (x) { return order.indexOf(x) < 0; });
          state.pending = {
            kind: "choose", player: p, tag: "target",
            prompt: "Put back on top: pick the next card (top-down order)",
            src: item.label, cands: left, min: 1, max: 1, varKey: "predictPick",
          };
          return "wait";
        }
        order.push(item.vars.predictPick[0]);
        delete item.vars.predictPick;
      }
      const tail = remaining.filter(function (x) { return order.indexOf(x) < 0; });
      const finalOrder = order.concat(tail);
      for (const fIid of finalOrder) {
        const di = player.mainDeck.indexOf(fIid);
        if (di >= 0) player.mainDeck.splice(di, 1);
      }
      for (let i = finalOrder.length - 1; i >= 0; i--) player.mainDeck.unshift(finalOrder[i]);
      delete item.vars.predictSet;
      delete item.vars.predictRecycled;
      delete item.vars.predictRemaining;
      delete item.vars.predictOrder;
      return;
    },

    nameChoice(state, item, op, p, opp) {
      const src = item.source || item.iid;
      const so = src && state.objs[src];
      if (!so) return;
      const key = op.varKey || ("nm" + item.pc);
      const opts = FX.nameOptions(state, item, op);
      const kind = op.kind || "tag";
      if (FX.ask(state, item, key, {
        player: p, tag: "name", options: opts, nameKind: kind, nameType: op.type || null,
        prompt: op.prompt || (kind === "card" ? "Name a card" : "Name a tag"),
      })) return "wait";
      const v = item.vars[key];
      const picked = typeof v === "string" ? v : opts[v];
      if (picked === undefined) return;
      so.named = { kind: op.kind || "tag", value: picked };
      FX.opLog(state, item, "reveal", Core.name(state, src) + " names " + picked + ".");
      return;
    },
  });
})();
